import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Spinner } from '../Spinner';
import { SafeAnchor } from '../SafeAnchor';
// eslint-disable-next-line react/display-name
export const Button = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { className, componentClass = 'button', bsStyle = 'default', type = 'button', bsSize, active, onClick, icon, loading, disabled, children, ...rest } = props;
    let Component = componentClass;
    if (props.href) {
        Component = SafeAnchor;
    }
    const bsClass = classnames('btn', `btn-${bsStyle}`, {
        [`btn-${bsSize}`]: !!bsSize
    }, {
        'active': !!active
    }, className);
    let Icon = null;
    if (icon && !loading) {
        Icon = /*#__PURE__*/ _jsx(FontAwesomeIcon, {
            icon: icon,
            fixedWidth: true,
            className: "me-2 button-icon"
        });
    }
    if (loading) {
        Icon = /*#__PURE__*/ _jsx("span", {
            className: "d-inline-block me-2 fa-fw",
            children: /*#__PURE__*/ _jsx(Spinner, {
                bsSize: "sm"
            })
        });
    }
    return /*#__PURE__*/ _jsxs(Component, {
        ...rest,
        ref: ref,
        type: type,
        onClick: onClick,
        className: bsClass,
        disabled: disabled || loading,
        children: [
            Icon,
            children
        ]
    });
});
